<app-slide-in-modal size="lg" #modal [layer]="layer()">
  <ng-container title i18n>Modifier la demande</ng-container>

  <div body>
    <form
      [formGroup]="form"
      class="lty-form edit-form"
      (submit)="$event.preventDefault()"
    >
      <div class="edit-group">
        <h3 class="edit-group__title" i18n>Demande</h3>
        <div class="split-form-body">
          <div class="form-group flex-basis-50">
            <label i18n>Client</label>
            <input
              type="text"
              class="form-control"
              [value]="cancellation?.userName ?? ''"
              disabled
            />
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>Membre de la famille</label>
            <input
              type="text"
              class="form-control"
              [value]="cancellation?.memberName ?? ''"
              disabled
            />
          </div>

          <div class="form-group flex-basis-50">
            <label for="edit-insurance-type" i18n
              >Type d'assurance à résilier</label
            >
            <div class="position-relative">
              <select
                class="form-control"
                id="edit-insurance-type"
                formControlName="insuranceType"
              >
                @for (type of insuranceTypes; track type) {
                  <option [value]="type">
                    {{ getInsuranceTypeLabel(type) }}
                  </option>
                }
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
            @if (branchLocked) {
              <span class="edit-hint" i18n
                >Fixé par l'affaire liée à cette résiliation.</span
              >
            }
          </div>

          <div class="form-group flex-basis-50">
            <label for="edit-category" i18n>Compagnie d'assurance</label>
            <div class="position-relative">
              <select
                class="form-control"
                id="edit-category"
                formControlName="categoryId"
              >
                <option value="" disabled i18n>Sélectionner</option>
                @for (company of companies; track company.categoryId) {
                  <option [value]="company.categoryId">
                    {{ companyLabel(company) }}
                  </option>
                }
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
            @if (insurerLocked) {
              <span class="edit-hint" i18n>Celle de la police à résilier.</span>
            }
          </div>

          <div class="form-group flex-basis-100">
            <label for="edit-policy-number" i18n>N° de police</label>
            <input
              type="text"
              class="form-control"
              id="edit-policy-number"
              formControlName="policyNumber"
            />
            @if (policyNumberLocked) {
              <span class="edit-hint" i18n>Celui de la police à résilier.</span>
            }
          </div>
        </div>
      </div>

      <div class="edit-group">
        <h3 class="edit-group__title" i18n>Envoi de la résiliation</h3>
        <div class="split-form-body">
          <div class="form-group flex-basis-50">
            <label for="edit-send-method" i18n
              >Méthode d'envoi à la compagnie d'assurance</label
            >
            <div class="position-relative">
              <select
                class="form-control"
                id="edit-send-method"
                formControlName="sendMethod"
              >
                @for (method of sendMethods; track method) {
                  <option [value]="method">
                    {{ getCancellationSendMethodLabel(method) }}
                  </option>
                }
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label for="edit-cancellation-date" i18n>Date de résiliation</label>
            <input
              class="form-control"
              type="date"
              id="edit-cancellation-date"
              formControlName="cancellationDate"
            />
          </div>
          <div class="form-group flex-basis-100">
            <label for="edit-comment" i18n>Informations supplémentaires</label>
            <textarea
              class="form-control"
              id="edit-comment"
              rows="3"
              formControlName="comment"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      i18n
    >
      Annuler
    </button>
    <button
      type="button"
      class="lty-btn lty-btn-primary"
      [disabled]="!canSubmit"
      (click)="submit()"
      i18n
    >
      Enregistrer
    </button>
  </div>
</app-slide-in-modal>
